import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=5d09eacb&scoped=true&lang=html"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d09eacb",
  null
  
)

export default component.exports